<div>
    <div class="dialog_content">

        <div class="form_row">

            <div class="form_row_item">
                <input type="text" pInputText [(ngModel)]="edits.codice" (input)="verifyEditsValidity()" />
            </div>

            <div class="form_row_item">
                <p-dropdown styleClass="form_select_mid" appendTo="body" [options]='optionsAziende' [(ngModel)]="edits.azienda" [disabled]="!modeCreate" (onChange)="verifyEditsValidity()" placeholder="Impresa"></p-dropdown>
            </div>

            <div class="form_row_item">
                <p-multiSelect styleClass="form_select_mid" appendTo="body" [options]='optionsRegioni' [(ngModel)]="edits.regioni" (onChange)="verifyEditsValidity()" placeholder="Regioni di competenza"></p-multiSelect>
            </div>

        </div>

        <div class="form_row field">
            <textarea id="field_indirizzo" style="width: 100%" rows="2" type="text" pInputTextarea [(ngModel)]="edits.indirizzo" (input)="verifyEditsValidity()" placeholder="Indirizzo"></textarea>
        </div>

        <div class="form_row field">
            <textarea id="field_referente" style="width: 100%" rows="3" type="text" pInputTextarea [(ngModel)]="edits.referente" (input)="verifyEditsValidity()" placeholder="Referente"></textarea>
        </div>



    </div>

    <p-divider type="solid"></p-divider>

    <div class="dialog_controls">

            <p-button icon="pi pi-times" label="Annulla" class="p-button-text mr-1 row_button" (click)="onActivityCompleted(false)"></p-button>
            <p-button icon="pi pi-check" label="Conferma" class="p-button-text ml-100 row_button" styleClass="p-button-success" (click)="onActivityCompleted(true)" [disabled]="!hasValidForm"></p-button>
    </div>
</div>